import React from 'react';
import ReportesRecepcion from './ReportesRecepcion';

/**
 * Estadísticas del bot: el Resumen de Reportes Recepción completo, solo con los turnos de la
 * referencia marcada como bot en Datos Maestros (referencias.es_bot, V226).
 */
export default function ReportesRecepcionBot() {
    return <ReportesRecepcion soloBot />;
}
